export class ProductTotalHistoryItem {
    ID: number;
    DisplayName: string;
    PaidTotal: number;
    FreeTotal: number;
    DateCreated: Date;
    DateTimeCreated: Date;
    Product_ID: number;

    public static FixDates(item: ProductTotalHistoryItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
        item.DateCreated = new Date(item.DateCreated);
    }

}

export class ProductTotalHistoryItemArray extends Array<ProductTotalHistoryItem> {

    constructor(...items: ProductTotalHistoryItem[]) {
        super(...items);
        Object.setPrototypeOf(this, ProductTotalHistoryItemArray.prototype);
    }

    public static FixDates(item: ProductTotalHistoryItemArray) {
        item.forEach(x => ProductTotalHistoryItem.FixDates(x));
    }

}
